'use client';

import type { IErrorResponse } from '@/types';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import queryString from 'query-string';

import useSaveUrlFile from '../useSaveUrlFile';

import urls from '@/statics/urls';
import { api } from '@/utils';

export type StaticPagesPdfQueries = {
  type: string;
};

const useStaticPagesPdf = (
  queries: StaticPagesPdfQueries,
  enabled = false
): UseQueryResult<string, IErrorResponse> => {
  const { saveBlobFile } = useSaveUrlFile();

  return useQuery<string, IErrorResponse>({
    queryKey: [`${urls.downloadContract}?${queryString.stringify(queries)}`],
    queryFn: async () => {
      const queryStr = queryString.stringify(queries);
      const url = `${urls.downloadContract}?${queryStr}`;

      const response: Blob = await api.get(url, {
        baseURL: '',
        responseType: 'blob',
        transformResponse: (result: { data: Blob }) => {
          return {
            data: result,
          };
        },
      });

      await saveBlobFile(response, 'document.pdf');
      return 'Done';
    },
    enabled: enabled && Boolean(queries.type),
  });
};

export default useStaticPagesPdf;
